.root {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px;
  width: 170px;
  box-sizing: content-box;
}

.swatch {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 0;
  cursor: pointer;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--icon-on-primary);
  outline: 1px solid transparent;
  box-sizing: border-box;
  transition: outline-color 120ms ease, border-color 120ms ease;
}

.swatch:hover,
.swatch.selected {
  border: 2px solid var(--surface-inverse);
  outline: 1px solid var(--chartv2-palette-swatch-color);
}

.check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
}
